import Vue from 'vue';
import Router from 'vue-router';

import setSidebarMenuActive from './utils/sidebarMenuActive.js';
import UsersListTable from './components/users/templates/UsersListTable.vue';
import BodiesListTable from './components/predefined-bodies/bodies/BodiesListTable';
import CategoriesListComponent from './components/predefined-bodies/categories/CategoriesListComponent';
import ListTable from './components/contacts-lists/lists/ListTable';
import ListsCategoriesComponent from './components/contacts-lists/categories/CategoriesComponent';
import ListsTemplateComponent from './components/contacts-lists/templates/TemplateComponent';
import ShortDomainsTable from './components/short-domains/ShortDomainsTable';
import SDAccountsTable from './components/short-domain-acconts/template/SDAccountsTable';
import DLRReportComponent from './components/dlr-report/DLRReportComponent';
import ClickerReportComponent from './components/clicker-report/ClickerReportComponent';
import NonClickerReportComponent from './components/non-clicker-report/NonClickerReportComponent';

import ShortDomainsList from './views/short-domains/ShortDomainsList';
import ShortDomainsShow from './views/short-domains/ShortDomainsShow';
import ShortDomainsEdit from './views/short-domains/ShortDomainsEdit';
import ShortDomainsNew from './views/short-domains/ShortDomainsNew';
import ShortDomainsSettings from './views/short-domains/settings/ShortDomainsSettings';

import BrandsList from '@/views/brands/BrandsList';
import BrandsShow from '@/views/brands/BrandsShow';
import BrandsEdit from '@/views/brands/BrandsEdit';
import BrandsCreate from '@/views/brands/BrandsCreate';

import FileTable from '@/components/api-source-numbers/file/FileTable';

import ApisTable from '@/components/apis/ApisTable';

import ApisList from '@/views/apis/ApisList';
import ApisShow from '@/views/apis/ApisShow';

import ApisAccountsList from '@/views/apis/accounts/ApisAccountsList';
import ApisAccountsShow from './views/apis/accounts/ApisAccountsShow';
import ApisAccountsEdit from './views/apis/accounts/ApisAccountsEdit';
import ApisAccountsCreate from './views/apis/accounts/ApisAccountsCreate';

import ApisTagsList from './views/apis/tags/ApisTagsList';
import ApisTagsShow from './views/apis/tags/ApisTagsShow';
import ApisTagsCreate from './views/apis/tags/ApisTagsCreate';
import ApisTagsEdit from './views/apis/tags/ApisTagsEdit';

import AdditionalExports from './views/additional/exports/AdditionalExports';
import AdditionalUnsuspend from './views/additional/unsuspend/AdditionalUnsuspend';
import AdditionalUnblacklist from './views/additional/unblacklist/AdditionalUnblacklist';

import OffersList from './views/offers/OffersList';

import OffersTagsList from './views/offers/tags/OffersTagsList';
import OffersTagsShow from './views/offers/tags/OffersTagsShow';
import OffersTagsCreate from './views/offers/tags/OffersTagsCreate';
import OffersTagsEdit from './views/offers/tags/OffersTagsEdit';

import ListsBatchContactsList from './views/lists/batch-contacts/ListsBatchContactsList';
import ListsBatchContactsShow from './views/lists/batch-contacts/ListsBatchContactsShow';
import ListsBatchContactsCreate from './views/lists/batch-contacts/ListsBatchContactsCreate';
import ListsBatchContactsEdit from './views/lists/batch-contacts/ListsBatchContactsEdit';

import Dashboard from './views/dashboard/Dashboard';
import CategoriesTagsList from "./views/lists/categories/tags/CategoriesTagsList";
import CategoriesTagsCreate from "./views/lists/categories/tags/CategoriesTagsCreate.vue";
import CategoriesTagsEdit from "./views/lists/categories/tags/CategoriesTagsEdit.vue";
import CategoriesTagsShow from "./views/lists/categories/tags/CategoriesTagsShow.vue";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/brands',
            component: {
                render: (c) => c('router-view'),
            },
            children: [
                {
                    path: '/brands',
                    name: 'brands.list',
                    component: BrandsList,
                },
                {
                    path: 'new',
                    name: 'brands.create',
                    component: BrandsCreate,
                },
                {
                    path: ':id/edit',
                    name: 'brands.edit',
                    component: BrandsEdit,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        return next({ name: 'brands.list' });
                    },
                },
                {
                    path: ':id',
                    name: 'brands.show',
                    component: BrandsShow,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        else if (to.params.id === 'new') return next({ name: 'brands.create' });
                        return next({ name: 'brands.list' });
                    },
                },
            ],
        },
        {
            path: '/offers',
            component: {
                render: (c) => c('router-view'),
            },
            children: [
                {
                    path: '/offers',
                    name: 'offers.list',
                    component: OffersList,
                },
                {
                    path: '/offers/tags',
                    component: {
                        render: (c) => c('router-view'),
                    },
                    children: [
                        {
                            path: '/offers/tags',
                            name: 'offers.tags.list',
                            component: OffersTagsList,
                        },
                        {
                            path: 'new',
                            name: 'offers.tags.create',
                            component: OffersTagsCreate,
                        },
                        {
                            path: ':id/edit',
                            name: 'offers.tags.edit',
                            component: OffersTagsEdit,
                            beforeEnter: (to, from, next) => {
                                if (!isNaN(to.params.id && Number(to.params.id))) return next();
                                return next({ name: 'offers.tags.list' });
                            },
                        },
                        {
                            path: ':id',
                            name: 'offers.tags.show',
                            component: OffersTagsShow,
                            beforeEnter: (to, from, next) => {
                                if (!isNaN(to.params.id && Number(to.params.id))) return next();
                                else if (to.params.id === 'new') return next({ name: 'offers.tags.create' });
                                return next({ name: 'offers.tags.list' });
                            },
                        },
                    ],
                },
            ],
        },
        {
            path: '/users',
            name: 'users.list.table',
            component: UsersListTable,
        },
        {
            path: '/predefined-bodies',
            name: 'bodies.list.table',
            component: BodiesListTable,
        },
        {
            path: '/predefined-bodies/categories',
            name: 'bodies.categories.list',
            component: CategoriesListComponent,
        },
        {
            path: '/predefined-bodies/categories/:id',
            name: 'category.bodies.list.table',
            component: BodiesListTable,
        },
        {
            path: '/lists',
            name: 'contacts-lists.lists.table',
            component: ListTable,
        },
        {
            path: '/lists/live',
            name: 'contacts-lists.live.lists.table',
            component: ListTable,
        },
        {
            path: '/lists/categories',
            name: 'contacts-lists.categories.component',
            component: ListsCategoriesComponent,
        },
        {
            path: '/lists/categories/:id/show',
            name: 'contacts-lists.categories.filter',
            component: ListsTemplateComponent,
        },
        {
            path: '/lists/categories/tags',
            component: {
                render: (c) => c('router-view'),
            },
            children: [
                {
                    path: '/lists/categories/tags',
                    name: 'contacts-lists.categories.tags.list',
                    component: CategoriesTagsList,
                },
                {
                    path: 'new',
                    name: 'contacts-lists.categories.tags.create',
                    component: CategoriesTagsCreate,
                },
                {
                    path: ':id/edit',
                    name: 'contacts-lists.categories.tags.edit',
                    component: CategoriesTagsEdit,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        return next({ name: 'contacts-lists.categories.tags.list' });
                    },
                },
                {
                    path: ':id',
                    name: 'contacts-lists.categories.tags.show',
                    component: CategoriesTagsShow,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        else if (to.params.id === 'new') return next({ name: 'contacts-lists.categories.tags.create' });
                        return next({ name: 'contacts-lists.categories.tags.list' });
                    },
                },
            ]
        },
        {
            path: '/lists/tags/:id',
            name: 'contacts-lists.tags.filter',
            component: ListsTemplateComponent,
        },
        {
            path: '/lists/batch-contacts',
            component: {
                render: (c) => c('router-view'),
            },
            children: [
                {
                    path: '/lists/batch-contacts',
                    name: 'lists.batchContacts.list',
                    component: ListsBatchContactsList,
                },
                {
                    path: 'new',
                    name: 'lists.batchContacts.create',
                    component: ListsBatchContactsCreate,
                },
                {
                    path: ':id/edit',
                    name: 'lists.batchContacts.edit',
                    component: ListsBatchContactsEdit,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        return next({ name: 'lists.batchContacts.list' });
                    },
                },
                {
                    path: ':id',
                    name: 'lists.batchContacts.show',
                    component: ListsBatchContactsShow,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        else if (to.params.id === 'new') return next({ name: 'lists.batchContacts.create' });
                        return next({ name: 'lists.batchContacts.list' });
                    },
                },
            ],
        },
        {
            path: '/dashboard-advanced',
            name: 'dashboard.advanced',
            component: Dashboard,
        },
        {
            path: '/dlr-report',
            name: 'dlr.report',
            component: DLRReportComponent,
        },
        {
            path: '/clicker-report',
            name: 'clicker.report',
            component: ClickerReportComponent,
        },
        {
            path: '/non-clicker-report',
            name: 'non.clicker.report',
            component: NonClickerReportComponent,
        },
        {
            path: '/apis/providers',
            name: 'apis.providers',
            component: ApisTable,
        },
        {
            path: '/apis',
            component: {
                render: (c) => c('router-view'),
            },
            children: [
                {
                    path: '/apis',
                    name: 'apis.list',
                    component: ApisList,
                },
                {
                    path: ':id',
                    name: 'apis.show',
                    component: ApisShow,
                    beforeEnter: (to, from, next) => {
                        if (to.params.id === 'new') return next({ path: 'apis/new' });
                        else if (to.params.id === 'accounts') return next({ name: 'apis.accounts.list' });
                        else if (to.params.id === 'tags') return next({ name: 'apis.tags.list' });
                        return next();
                    },
                },
            ],
        },
        {
            path: '/apis/accounts',
            component: {
                render: (c) => c('router-view'),
            },
            children: [
                {
                    path: '/apis/accounts',
                    name: 'apis.accounts.list',
                    component: ApisAccountsList,
                },
                {
                    path: 'new',
                    name: 'apis.accounts.create',
                    component: ApisAccountsCreate,
                },
                {
                    path: ':id/edit',
                    name: 'apis.accounts.edit',
                    component: ApisAccountsEdit,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        return next({ name: 'apis.accounts.list' });
                    },
                },
                {
                    path: ':id',
                    name: 'apis.accounts.show',
                    component: ApisAccountsShow,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        else if (to.params.id === 'new') return next({ name: 'apis.accounts.create' });
                        return next({ name: 'apis.accounts.list' });
                    },
                },
            ],
        },
        {
            path: '/apis/tags',
            component: {
                render: (c) => c('router-view'),
            },
            children: [
                {
                    path: '/apis/tags',
                    name: 'apis.tags.list',
                    component: ApisTagsList,
                },
                {
                    path: 'new',
                    name: 'apis.tags.create',
                    component: ApisTagsCreate,
                },
                {
                    path: ':id/edit',
                    name: 'apis.tags.edit',
                    component: ApisTagsEdit,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        return next({ name: 'apis.tags.list' });
                    },
                },
                {
                    path: ':id',
                    name: 'apis.tags.show',
                    component: ApisTagsShow,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        else if (to.params.id === 'new') return next({ name: 'apis.tags.create' });
                        return next({ name: 'apis.tags.list' });
                    },
                },
            ],
        },
        {
            path: '/apis/:id:',
            name: 'apis.file.table',
            component: FileTable,
        },
        {
            path: '/short-domains',
            component: {
                render: (c) => c('router-view'),
            },
            children: [
                {
                    path: '/short-domains',
                    name: 'short-domains.list',
                    component: ShortDomainsList,
                },
                {
                    path: ':id/edit',
                    name: 'short-domains.edit',
                    component: ShortDomainsEdit,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        return next({ name: 'short-domains.list' });
                    },
                },
                {
                    path: ':id',
                    name: 'short-domains.show',
                    component: ShortDomainsShow,
                    beforeEnter: (to, from, next) => {
                        if (!isNaN(to.params.id && Number(to.params.id))) return next();
                        else if (to.params.id === 'settings') return next({ name: 'short-domains.settings' });
                        else if (to.params.id === 'tags') return next({ name: 'short-domains.tags' });
                        return next({ name: 'short-domains.list' });
                    },
                },
                {
                    path: 'settings',
                    name: 'short-domains.settings',
                    component: ShortDomainsSettings,
                },
                {
                    path: 'tags',
                    name: 'short-domains.tags',
                    component: {
                        render: (c) => c('router-view'),
                    },
                },
                {
                    path: 'new',
                    name: 'short-domains.new',
                    component: ShortDomainsNew,
                },
            ],
        },
        {
            path: '/sd-accounts',
            name: 'short-domain-accounts.list.table',
            component: SDAccountsTable,
        },
        {
            path: '/sd-accounts/{id}',
            name: 'short-domain-accounts.show.bottom.table',
            component: ShortDomainsTable,
        },
        {
            path: '/additional',
            component: {
                render: (c) => c('router-view'),
            },
            children: [
                {
                    path: 'exports',
                    name: 'additional.exports',
                    component: AdditionalExports,
                },
                {
                    path: 'unblacklist',
                    name: 'additional.unblacklist',
                    component: AdditionalUnblacklist,
                },
                {
                    path: 'unsuspend',
                    name: 'additional.unsuspend',
                    component: AdditionalUnsuspend,
                },
            ],
        },
    ],
});

function changeContentWrapperHeight() {
    setTimeout(() => {
        const header = document.querySelector('.main-header');
        const sidebar = document.querySelector('.main-sidebar .sidebar');
        const contentWrapper = document.querySelector('.content-wrapper');

        if (!header || !sidebar || !contentWrapper) {
            return;
        }

        contentWrapper.style.minHeight = `${sidebar.offsetHeight - header.offsetHeight}px`;
    }, 100);
}

router.afterEach(() => {
    setSidebarMenuActive();

    // TODO change when app will be on Vue.js
    changeContentWrapperHeight();
});

// TODO change when app will be on Vue.js
window.addEventListener('resize', changeContentWrapperHeight);

Vue.use(Router);

export default router;
